import axiosApi from '../../../../Shared/api/axiosApi'

class PayloadApi {
    static getPayload() {
        return axiosApi.get('CustomerService/Contacts', false).then(response => {
            return response;
        }).catch(error => {
            throw error;
        });
    }
}

export default PayloadApi;  